import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("i", {
  class: "fa fa-microphone-alt",
  title: "start recording"
}, null, -1)
const _hoisted_2 = {
  key: 1,
  class: "mic-icons"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("i", { class: "fa fa-microphone-alt-slash" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "mic-icons" }, [
  /*#__PURE__*/_createVNode("i", {
    class: "fa fa-microphone-alt",
    title: "stop recording"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Fragment, null, [
    (!_ctx.isRecording && !_ctx.state.isFirefox)
      ? (_openBlock(), _createBlock("button", {
          key: 0,
          class: "mic-icons",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.startRecording()))
        }, [
          _hoisted_1
        ]))
      : _createCommentVNode("", true),
    (_ctx.state.isFirefox)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _hoisted_3
        ]))
      : _createCommentVNode("", true),
    (_ctx.isRecording)
      ? (_openBlock(), _createBlock("div", {
          key: 2,
          class: "ripple-effect-icon",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.stopRecording && _ctx.stopRecording(...args)))
        }, [
          _hoisted_4
        ]))
      : _createCommentVNode("", true)
  ], 64))
}